
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.41 11.59l-3.53-3.54-.71.71 2.32 2.31A2 2 0 1021 14.72V20a1 1 0 01-1 1 1 1 0 01-1-1v-4a1 1 0 00-1-1h-1v-5a2 2 0 00-2-2h-4a2 2 0 00-2 2v12h8v-6h.8a.2.2 0 01.2.2V20a2 2 0 002 2 2 2 0 002-2v-7a2 2 0 00-.59-1.41zm-5.66 1.16a1 1 0 01-1 1h-3.5a1 1 0 01-1-1v-2.5a1 1 0 011-1h3.5a1 1 0 011 1zM20 14a1 1 0 111-1 1 1 0 01-1 1z"}})])
          )
        }
      }
    